import React from 'react';
import PillarPageTemplate from '../../components/PillarPageTemplate';
import { permisA1Data } from '../../data/pillars/permisA1';

export default function PillarPermisA1() {
  return <PillarPageTemplate data={permisA1Data} />;
}
